import templateUrl from 'emun.on-demand/templates/od-product-template-manager.htm'
import controller from 'emun.on-demand/templates/od-product-template-manager.controller'
import resolve from 'ioc/resolve'


const ProductTemplateManagerComponent = {
    bindings: {
        hideLeftNav: '@',
        panelType: '@',
        designId: '@',
        onPublish: '&',
        onSaved: '&'
    },
    controller,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl;
    }
};

export default ProductTemplateManagerComponent;